module.exports = __webpack_public_path__ + "img/6.7ebc9b26.svg";